import { TrafficSituationHelper } from '../../../../../helpers/traffic-situation.helper';
import { ITrafficSituation } from '../../../../../models/traffic-situation.model';
import { TranslationService } from '../../../../../services/translation.service';
import { IconMotif } from '../../Icon/icon-motif.enum';
import Fact from '../Fact';
import './style.scss';

function hasAiValidityPeriod(trafficSituation: ITrafficSituation): boolean {
  if (!trafficSituation.aiGeneratedInformation) return false;

  if (trafficSituation.aiGeneratedInformation.startTime && trafficSituation.aiGeneratedInformation.startTime.isValid) {
    return true;
  }

  if (trafficSituation.aiGeneratedInformation.endTime && trafficSituation.aiGeneratedInformation.endTime.isValid) {
    return true;
  }

  return false;
}

function hasRegularValidityPeriod(trafficSituation: ITrafficSituation): boolean {
  return trafficSituation.startTime.isValid || (trafficSituation.endTime !== undefined && trafficSituation.endTime.isValid);
}

export default function ValidityPeriodFact({
  trafficSituation,
  showOnlyAiEnhancedInformation = false,
  className = '',
}: {
  trafficSituation: ITrafficSituation;
  showOnlyAiEnhancedInformation?: boolean;
  className?: string;
}) {
  const hasAiValidityPeriodInfo = hasAiValidityPeriod(trafficSituation);

  // Show the validity period only if:
  // 1. AI-generated information is available and valid, or
  // 2. Regular validity period exists and we are not filtering to show only AI-enhanced information.
  if (!hasAiValidityPeriodInfo && (showOnlyAiEnhancedInformation || !hasRegularValidityPeriod(trafficSituation))) return null;

  const isPlanned = TrafficSituationHelper.isPlannedTrafficSituation(trafficSituation);

  // Use AI-generated validity period if available, otherwise use the regular validity period.
  const startTime = hasAiValidityPeriodInfo ? trafficSituation.aiGeneratedInformation?.startTime : trafficSituation.startTime;
  const endTime = hasAiValidityPeriodInfo ? trafficSituation.aiGeneratedInformation?.endTime : trafficSituation.endTime;

  return (
    <Fact
      iconMotif={isPlanned ? IconMotif.CalendarWithArrow : IconMotif.Calendar}
      className={className}
      altText={TranslationService.get('common.trafficsituation.validityperiod')}
      title={TranslationService.get('common.trafficsituation.validityperiod')}
    >
      <div className="validity-period-fact-grid">
        {isPlanned && (
          <>
            <div style={{ gridColumn: '1 / -1' }}>{TranslationService.get('common.trafficsituation.planned')}: </div>
          </>
        )}
        {startTime && (
          <>
            <div className="fw-bold">{TranslationService.get('common.from')}:</div>
            <div>{startTime.setLocale('sv').toFormat("cccc d MMMM 'kl' HH:mm")}</div>
          </>
        )}
        {endTime && (
          <>
            <div className="fw-bold">{TranslationService.get('common.to')}:</div>
            <div>{endTime.setLocale('sv').toFormat("cccc d MMMM 'kl' HH:mm")}</div>
          </>
        )}
      </div>
    </Fact>
  );
}
